<template>
  <div>
    <span v-if="form.docstatnextcheckdesc">
      <el-link type="primary" :underline="false" @click="getDocthList">{{form.docstatcheckstatusname}}--{{form.docstatnextcheckdesc}}</el-link>
    </span>
    <span v-else="">
      <el-link type="primary" :underline="false" @click="getDocthList">{{form.docstatcheckstatusname}}</el-link>
    </span>
    <el-dialog title="单据审批记录" :visible.sync="docthshow" width="80%" :close-on-click-modal="false" :show-close="false" center>
      <docth-index ref="docthindex" :form="form"></docth-index>
    </el-dialog>
  </div>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  import DocthIndex from "./docthIndex";
  export default {
    name: 'docStatus',
    props:{
      form: {docid: '',doctid: '',docno: '',docdate: ''}
    },
    data () {
      return {
        docthshow: false
      }
    },
    activated() {
      this.docthshow = false
    },
    created () {
    },
    mounted () {
    },
    watch: {
    },
    components: {DocthIndex},
    methods: {
      getDocthList() {
        console.log(this.form)
        this.$router.push({name: 'docthIndex', params: {form: this.form}})
//        this.docthshow = true
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
